import React from "react";
import ImageList from "./ImageList";
import { dateFormate } from "util/Util";
import {
  User,
  MapPin,
  Tag,
  Calendar,
  Cpu,
  Laptop,
  LucideIcon
} from "lucide-react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ViewProduct = (product: any) => {
  const {
    assign,
    type,
    status,
    owner,
    location,
    model,
    brand,
    assignDate,
    urls,
  } = product.product;

  const DetailItem = ({ icon: Icon, label, value, color }: { icon: LucideIcon; label: string; value?: string; color?: string }) => (
    <div className="flex items-start gap-3 p-3 rounded-xl border border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors w-full overflow-hidden">
      <div className={`mt-0.5 p-2 flex-shrink-0 rounded-lg ${color || 'bg-slate-100/50 dark:bg-slate-700/50'} text-slate-600 dark:text-slate-400`}>
        <Icon size={18} strokeWidth={2} />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-0.5 truncate" title={label}>
          {label}
        </p>
        <p className="text-sm font-semibold text-slate-800 dark:text-slate-200 truncate" title={value || "—"}>
          {value || "—"}
        </p>
      </div>
    </div>
  );

  return (
    <div className="max-w-2xl mx-auto font-sans antialiased">
      {product && (
        <div className="space-y-6 overflow-hidden">
          {/* Header Section */}
          <div className="flex flex-col sm:flex-row justify-between items-start gap-4 pb-4 border-b border-slate-100 dark:border-slate-700 w-full overflow-hidden">
            <div className="space-y-1 min-w-0 flex-1">
              <h2 className="text-xl font-bold text-slate-900 dark:text-white tracking-tight truncate" title={assign}>
                {assign}
              </h2>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-primary/10 dark:bg-primary/20 text-primary text-xs font-bold uppercase tracking-tight">
                  <Laptop size={12} />
                  {type === "IPhone" ? "iPhone" : type}
                </span>
                <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-bold uppercase tracking-tight ${(status?.toLowerCase() === 'running' || status?.toLowerCase() === 'working')
                    ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400'
                    : 'bg-orange-50 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400'
                  }`}>
                  <span className={`w-1.5 h-1.5 rounded-full ${status?.toLowerCase() === 'running' || status?.toLowerCase() === 'working' ? 'bg-emerald-500' : 'bg-orange-500'}`} />
                  {status}
                </span>
              </div>
            </div>
          </div>

          {/* Model Info Banner */}
          <div className="p-4 rounded-2xl bg-slate-50 dark:bg-slate-800/40 border border-slate-100 dark:border-slate-700/50 w-full overflow-hidden">
            <div className="flex items-center gap-3">
              <div className="p-2.5 flex-shrink-0 rounded-xl bg-white dark:bg-slate-700 text-primary shadow-sm">
                <Cpu size={20} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-xs font-medium text-slate-500 dark:text-slate-400">MODEL</p>
                <p className="text-lg font-bold text-slate-900 dark:text-white truncate" title={model}>{model}</p>
              </div>
            </div>
          </div>

          {/* Detail Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
            <DetailItem
              icon={User}
              label="Asset Owner"
              value={owner}
              color="bg-violet-50 dark:bg-violet-900/20"
            />
            <DetailItem
              icon={MapPin}
              label="Location"
              value={location}
              color="bg-emerald-50 dark:bg-emerald-900/20"
            />
            <DetailItem
              icon={Tag}
              label="Brand"
              value={brand}
              color="bg-amber-50 dark:bg-amber-900/20"
            />
            <DetailItem
              icon={Calendar}
              label="Assigned On"
              value={dateFormate(assignDate)}
              color="bg-rose-50 dark:bg-rose-900/20"
            />
          </div>

          {/* Image Gallery if available */}
          {urls && urls.length > 0 && (
            <div className="mt-4 pt-4 border-t border-slate-100 dark:border-slate-700">
              <p className="text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-3">
                Asset Images
              </p>
              <ImageList images={urls} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ViewProduct;